import React from 'react';
import { Typography, Box, Grid, Avatar, Paper } from '@mui/material';
import MarcoImg from '../../assets/images/marco.png';
import CarlaImg from '../../assets/images/carla.png';
import LuisImg from '../../assets/images/luis.png';

const testimonials = [
  {
    name: 'Marco R.',
    title: 'Taxi Driver, Punta Cana',
    image: MarcoImg,
    quote:
      'I used to recommend excursions to tourists all the time, but never got anything for it. With CanAm, I finally earn from my connections — and I see every booking in my dashboard.',
  },
  {
    name: 'Carla G.',
    title: 'Independent Travel Agent, Toronto',
    image: CarlaImg,
    quote:
      'This was my first time joining an affiliate program, and it’s honestly so simple. I just send the link to clients, and a few days later I get paid. It’s extra income with zero stress.',
  },
  {
    name: 'Luis F.',
    title: 'Hotel Front Desk Staff, Bávaro',
    image: LuisImg,
    quote:
      'I love how fast the payouts are. I referred three couples last week and already got my commissions. Plus, the excursions are safe — I feel good recommending them.',
  },
];

const Testimonials = () => (
  <Box width="100%" py={8} px={{ xs: 2, sm: 4, md: 8, lg: 20 }} bgcolor="#fff">
    <Box textAlign="center" mb={6}>
      <Typography
        variant="h4"
        fontWeight="bold"
        fontFamily="Lato"
        fontSize={{ xs: '1.5rem', md: '2rem' }}
      >
        Testimonials
      </Typography>
      <Typography
        variant="body1"
        mt={2}
        fontFamily="Lato"
        fontSize={{ xs: '14px', md: '16px' }}
        color="#555"
      >
        Real people. Real earnings. Real results.
      </Typography>
    </Box>

    <Grid container spacing={3} justifyContent="center">
      {testimonials.map((testimonial, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              border: '1px solid #e0e0e0',
              p: { xs: 2, sm: 3 },
              height: '100%',
            }}
          >
            <Box display="flex" alignItems="center" mb={2}>
              <Avatar
                src={testimonial.image}
                alt={testimonial.name}
                sx={{ width: 56, height: 56, mr: 2 }}
              />
              <Box>
                <Typography fontWeight={700} fontFamily="Lato">
                  {testimonial.name}
                </Typography>
                <Typography
                  fontSize="14px"
                  color="#555"
                  fontFamily="Lato"
                >
                  {testimonial.title}
                </Typography>
              </Box>
            </Box>
            <Typography
              fontSize={{ xs: '14px', md: '15px' }}
              color="#333"
              fontFamily="Lato"
            >
              {testimonial.quote}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default Testimonials;
